/* eslint-disable no-unused-vars */
import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

//  Find every vote that has been made, and add up the score
const getFeatureVotesByUidAndItemKey = ({ uid, itemKey }) => firestore.collection('featureVotes')
	.where('uid', '==', uid)
	.where('itemKey', '==', itemKey)
	.get()
	.catch(exception => Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, uid, itemKey, exception)))
	.then((docs) => {
		const userVotes = []
		docs.forEach((snap) => {
			if (snap.exists) {
				const data = snap.data()
				userVotes.push(data)
			}
		})
		return { userVotes }
	})

export default getFeatureVotesByUidAndItemKey



// WEBPACK FOOTER //
// ./src/dataservices/getFeatureVotesByUidAndItemKey.js